<button type="button" class="rh-fab" [class.open]="open" (click)="toggle()" aria-label="Registration help chat">
  <span *ngIf="unreadCount > 0" class="rh-fab-badge">{{ unreadCount }}</span>
  <svg *ngIf="!open" class="rh-fab-icon" viewBox="0 0 24 24" fill="none">
    <path d="M12 3C7.03 3 3 6.58 3 11c0 2.05.87 3.92 2.3 5.33-.13 1.05-.56 2.28-1.52 3.27-.2.2-.05.55.23.52 1.94-.2 3.4-.94 4.4-1.65 1.1.34 2.3.53 3.59.53 4.97 0 9-3.58 9-8s-4.03-8-9-8Z" fill="currentColor"/>
    <circle cx="8.5" cy="11" r="1.15" fill="#fff"/>
    <circle cx="12" cy="11" r="1.15" fill="#fff"/>
    <circle cx="15.5" cy="11" r="1.15" fill="#fff"/>
  </svg>
  <svg *ngIf="open" class="rh-fab-icon" viewBox="0 0 24 24" fill="none">
    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
  </svg>
</button>

<div class="rh-panel" *ngIf="open">
  <div class="rh-header">
    <div class="rh-header-avatar">💬</div>
    <div class="rh-header-text">
      <strong>Registration help</strong>
      <span>We usually reply within one business day</span>
    </div>
  </div>

  <div *ngIf="signedIn" class="rh-start">
    <p class="rh-start-hello">👋 Hi! You're signed in as <strong>{{ signedInEmail }}</strong>. Your conversation with our staff lives in Chat, where it stays tied to your vendor account.</p>
    <button type="button" class="rh-send-btn wide" (click)="openChat()">Open Chat</button>
  </div>

  <div *ngIf="!signedIn && !hasInquiry" class="rh-start">
    <p class="rh-start-hello">👋 Hi! Ask us anything about registering as a vendor — no account needed.</p>
    <div class="rh-field">
      <label>Your name</label>
      <input type="text" [(ngModel)]="guestName" (ngModelChange)="onComposerInput()" placeholder="Jane Smith" />
    </div>
    <div class="rh-field">
      <label>Your email</label>
      <input type="email" [(ngModel)]="guestEmail" (ngModelChange)="onComposerInput()" placeholder="jane@company.com" />
    </div>
    <div class="rh-field">
      <label>Your question</label>
      <textarea rows="3" [(ngModel)]="newMessageText" (ngModelChange)="onComposerInput()" placeholder="How do I…"></textarea>
    </div>
    <div class="rh-error" *ngIf="startError">{{ startError }}</div>
    <button type="button" class="rh-send-btn wide" (click)="start()" [disabled]="sending">
      {{ sending ? 'Sending…' : 'Start the conversation' }}
    </button>
  </div>

  <ng-container *ngIf="!signedIn && hasInquiry">
    <div class="rh-messages" #messageScroll>
      <div class="rh-welcome" *ngIf="messages.length > 0">
        You're chatting with our staff, {{ storedName }} — replies also stay here if you come back later.
      </div>
      <div
        *ngFor="let message of messages"
        class="rh-row"
        [class.own]="message.senderSide === 'Guest'"
        [class.has-reactions]="message.guestReaction || message.staffReaction"
      >
        <div class="rh-bubble" [class.own]="message.senderSide === 'Guest'">
          <div class="rh-sender" *ngIf="message.senderSide === 'Staff'">{{ message.senderDisplayName }}</div>
          <a *ngIf="message.attachmentUrl && isImage(message.attachmentMimeType)" class="rh-attachment-image" [href]="message.attachmentUrl" target="_blank" rel="noopener">
            <img [src]="message.attachmentUrl" [alt]="message.attachmentName" />
          </a>
          <a *ngIf="message.attachmentUrl && !isImage(message.attachmentMimeType)" class="rh-attachment-chip" [href]="message.attachmentUrl" target="_blank" rel="noopener">
            <span class="rh-attachment-icon">📎</span>
            <span class="rh-attachment-name">{{ message.attachmentName }}</span>
          </a>
          <div class="rh-text" *ngIf="message.text">{{ message.text }}</div>
          <div class="rh-time">
            {{ message.createdDate + 'Z' | date: 'MMM d, h:mm a' }}
            <span *ngIf="message.senderSide === 'Guest' && message.isReadByStaff" class="rh-read">✓ Seen</span>
          </div>
          <div class="rx-chips" *ngIf="message.guestReaction || message.staffReaction">
            <span *ngIf="message.guestReaction">{{ message.guestReaction }}</span>
            <span *ngIf="message.staffReaction">{{ message.staffReaction }}</span>
          </div>
        </div>
        <div class="rx-anchor">
          <button type="button" class="rx-add" title="React" (click)="toggleReactionPicker(message.id)">🙂</button>
          <div class="rx-picker" *ngIf="reactionPickerFor === message.id">
            <button
              type="button"
              *ngFor="let reaction of reactionOptions"
              [class.active]="message.guestReaction === reaction"
              (click)="react(message, reaction)"
            >{{ reaction }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="rh-error rh-error-composer" *ngIf="startError">{{ startError }}</div>

    <div class="rh-filechip" *ngIf="pendingFile">
      <span class="rh-attachment-icon">📎</span>
      <span class="rh-attachment-name">{{ pendingFile.name }}</span>
      <button type="button" class="rh-filechip-remove" (click)="clearFile()">✕</button>
    </div>

    <div class="rh-emoji-pop" *ngIf="emojiOpen">
      <button type="button" class="rh-emoji" *ngFor="let emoji of emojis" (click)="addEmoji(emoji)">{{ emoji }}</button>
    </div>

    <div class="rh-composer">
      <button type="button" class="rh-tool" (click)="toggleEmoji()" title="Emoji" [class.active]="emojiOpen">😊</button>
      <button type="button" class="rh-tool" (click)="pickFile()" title="Attach a file">📎</button>
      <input type="file" #fileInput hidden (change)="onFileSelected($event)"
        [attr.accept]="imageAccept" />
      <textarea
        rows="1"
        [(ngModel)]="newMessageText"
        (ngModelChange)="onComposerInput()"
        placeholder="Type your message…"
        (keydown.enter)="$event.preventDefault(); send()"
        (focus)="emojiOpen = false"
      ></textarea>
      <button type="button" class="rh-send-btn" (click)="send()" [disabled]="sending || (!newMessageText.trim() && !pendingFile)">
        <svg viewBox="0 0 24 24" fill="none"><path d="M3.4 20.4 20.85 12 3.4 3.6l-.01 6.53L14 12 3.39 13.87l.01 6.53Z" fill="currentColor"/></svg>
      </button>
    </div>
  </ng-container>
</div>
